import React from 'react';
import moment from 'moment';

import { Avatar, MCButton } from 'src/components/basic';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { countFormat, lang, userFullName } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

export class DoctorInfoPanel extends BaseComponent {
  render() {
    const { doctor: detail, closeBtn, hideHeader = false, freeChatEl } = this.props;
    const doctor = { ...detail, ...detail.partnerProfile };
    let experience = doctor.yearOfStarting
      ? moment().year() - doctor.yearOfStarting + 1
      : doctor.training;
    if (experience > 0) {
      experience = lang.t(experience > 1 ? LANG_CONST.amount_years : LANG_CONST.amount_year, {
        amount: experience
      });
    }
    return (
      <div className='mc-doctor-info-right'>
        {!hideHeader && (
          <div className={'mc-header'}>
            <div className={'mc-flex'}>
              <div className={'mc-pointer mc-flex'} onClick={closeBtn}>
                <SVGIcon width={30} iconname={BASE_ICONS.CLOSE} />
              </div>
              <div className={'mc-title'}>{lang.t(LANG_CONST.titles.doctor_info)}</div>
            </div>
            <div className={'mc-bt mc-mt15'} />
          </div>
        )}
        <div className={'mc-fix-wrap'}>
          <div className={'mc-p20 mc-flex-20-col'}>
            <Avatar
              width={100}
              height={100}
              text={userFullName(doctor)}
              onlineState={(doctor.online || doctor.partnerOnline) > 0 ? 'online' : ''}
              image={(doctor?.avatar || '').replace('/full_', '/350_')}
            />
            <div className={'mc-flex-10-col'}>
              <div className={'mc-value-520'}>{userFullName(doctor, doctor.isDoctor)}</div>
              <div className={'mc-label-418'}>
                {doctor.specialist
                  ?.filter((v) => !!LANG_CONST.constants.specialist[v])
                  .map((v) => lang.t(LANG_CONST.constants.specialist[v]))
                  .join(', ')}
              </div>
              <pre className={'mc-label-416'}>{doctor.address}</pre>
            </div>
            <MCButton light primary medium radius onClick={this.props.viewProfile}>
              {lang.t(LANG_CONST.buttons.view_profile)}
            </MCButton>
            <div className={'mc-flex-15-col'}>
              {doctor.school && (
                <div className={'mc-flex'}>
                  <SVGIcon iconname={'university-icon'} width={50} height={50} />
                  <div className={'mc-value-416 mc-grow'}>
                    {lang.t(LANG_CONST.studies_at, { school: doctor.school })}
                  </div>
                </div>
              )}
              {doctor.hospitalAffiliations && (
                <div className={'mc-flex'}>
                  <SVGIcon iconname={'graduate-icon'} width={50} height={50} />
                  <div className={'mc-value-416 mc-grow'}>
                    {lang.t(LANG_CONST.practicing_at, { school: doctor.hospitalAffiliations })}
                  </div>
                </div>
              )}
              {doctor.patientCount && (
                <div className={'mc-flex'}>
                  <SVGIcon iconname={'patient-icon'} width={50} height={50} />
                  <div className={'mc-value-416 mc-grow'}>
                    {lang.t(LANG_CONST.amount_happy_patients, {
                      amount: countFormat(doctor.patientCount)
                    })}
                  </div>
                </div>
              )}
            </div>
            {freeChatEl}
            <div className={'mc-flex-15-col'}>
              <div className={'mc-flex'}>
                <div className={'mc-label-416 mc-grow'}>
                  {lang.t('Total')} {lang.t(LANG_CONST.treatment)}
                </div>
                <div className={'mc-value-716'}>{countFormat(doctor.treatmentCount)}</div>
              </div>
              {!!experience && (
                <div className={'mc-flex'}>
                  <div className={'mc-label-416 mc-grow'}>{lang.t(LANG_CONST.experience)}</div>
                  <div className={'mc-value-716'}>{experience}</div>
                </div>
              )}
              <div className={'mc-flex'}>
                <div className={'mc-label-416 mc-grow'}>{lang.t(LANG_CONST.date_of_joining)}</div>
                <div className={'mc-value-716'}>
                  {doctor.created && moment(doctor.created).format('DD MMM YYYY')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
